import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Chi tiết bộ phận")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", {
  class: "las la-reply",
  style: {"font-size":"1.5em"}
}, null, -1)
const _hoisted_5 = { class: "card-body p-9" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "col-2 d-flex align-items-center fs-6 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Tên chức vụ:")
], -1)
const _hoisted_8 = { class: "col-3 d-flex align-items-center" }
const _hoisted_9 = { class: "mb-0" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "row" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "col-2 d-flex align-items-center fs-6 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Tên viết tắt:")
], -1)
const _hoisted_13 = { class: "col-3 d-flex align-items-center" }
const _hoisted_14 = { class: "mb-0" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Edit = _resolveComponent("Edit")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", null, [
        _createVNode(_component_router_link, {
          to: "/quan-ly/chuc-vu/danh-sach",
          class: "btn btn-primary align-self-center me-2"
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: _ctx.updateLinkComputed,
          class: "btn btn-success align-self-center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_icon, { style: {"font-size":"1.5em"} }, {
              default: _withCtx(() => [
                _createVNode(_component_Edit)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            (_ctx.positionDetail)
              ? (_openBlock(), _createBlock(_component_el_input, {
                  key: 0,
                  modelValue: _ctx.positionDetail.ten_chuc_vu,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.positionDetail.ten_chuc_vu) = $event)),
                  name: "name",
                  readonly: "",
                  disabled: ""
                }, null, 8, ["modelValue"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            (_ctx.positionDetail)
              ? (_openBlock(), _createBlock(_component_el_input, {
                  key: 0,
                  modelValue: _ctx.positionDetail.ten_viet_tat,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.positionDetail.ten_viet_tat) = $event)),
                  name: "shortName",
                  readonly: "",
                  disabled: ""
                }, null, 8, ["modelValue"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _hoisted_15
    ])
  ]))
}